var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67631 18.3733C13.95 18.3733 17.4174 14.8469 17.4174 10.5003C17.4174 6.15376 13.95 2.62731 9.67631 2.62731C6.79599 2.62731 4.15759 4.25111 2.81903 6.84593L0.535422 5.62561C3.18351 0.488472 9.4215 -1.48962 14.4693 1.2036C19.5171 3.89683 21.4653 10.2412 18.8172 15.375C16.1691 20.5089 9.93112 22.4903 4.88331 19.797C3.02546 18.8063 1.5095 17.2645 0.535422 15.375L2.81903 14.1547C4.15436 16.7495 6.79599 18.3733 9.67631 18.3733ZM9.78597 9.18815L7.52817 6.89185L9.35376 5.03513L13.8145 9.57196C14.3177 10.0837 14.3177 10.9136 13.8145 11.4287L9.35376 15.9655L7.52817 14.1088L9.78597 11.8125H0V9.18815H9.78597Z",
    fill: "#FFBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5b1362bce5b9434e25df8125a2f1e527.svg";
export { ForwardRef as ReactComponent };